module.exports = __webpack_public_path__ + "img/h-page4-7.7921260d.png";